'use client';

import * as React from 'react';

import { useRouter, useParams, useSearchParams } from 'next/navigation';

import { useQuery } from '@tanstack/react-query';

import { queryFunctions } from '@hub/common/src/query-functions';

import { useCitOriginClient } from '@hub/common-components/src/CitOriginClientProvider';

import EntryDetailLayout from '@hub/common-components/src/EntryDetailLayout';
import LoadingSkeleton from '@hub/common-components/src/LoadingSkeleton';
import { useCitThemeClient } from '@hub/common-components/src/CitThemeProvider';

export default function IFrameEntry() {
  const { accountId, folderId, entryId } = useParams<{
    accountId: string;
    folderId: string;
    entryId: string;
  }>();

  const searchParams = useSearchParams();

  // when nav = 0, hide the back button
  const nav = searchParams.get('nav');

  const query = searchParams.get('query');

  const citOrigin = useCitOriginClient();
  const router = useRouter();
  const {
    data: entry,
    isLoading,
    isFetching
  } = useQuery({
    queryKey: ['entry', { accountId, folderId, entryId, citOrigin }],
    queryFn: queryFunctions.getEntryDetails
  });

  const { accountTheme } = useCitThemeClient();
  const bgColor = accountTheme.backgroundColor(entry);

  if (isLoading || isFetching || !entry) {
    return <LoadingSkeleton />;
  }

  return (
    <>
      <div className='h-full flex flex-col'>
        <nav
          className={`p-4 w-full z-30 flex ${nav === '0' ? 'hidden' : ''}`}
          style={{ backgroundColor: bgColor }}
        >
          <button
            className='justify-start text-blue-600 hover:text-blue-800 hover:underline cursor-pointer'
            onClick={() =>
              router.replace(
                '/iframe/' +
                  accountId +
                  (folderId ? `/folder/${folderId}` : '') +
                  (query ? `?query=${encodeURIComponent(query)}` : '')
              )
            }
          >
            Back
          </button>
        </nav>
        <div className='flex-1 overflow-hidden'>
          <EntryDetailLayout entry={entry} accountId={accountId} />
        </div>
      </div>
    </>
  );
}
